var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emergency"},[_c('div',{staticStyle:{"height":"453px"}}),_c('LowerThird',{attrs:{"channel":_vm.channel,"platform":_vm.platform}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }